// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xbuycshcwtejlcdipbng.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhidXljc2hjd3RlamxjZGlwYm5nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0ODYxODMsImV4cCI6MjA4NzA2MjE4M30.NVQBHsKyN4W-z8kel72nkWRYpODVCxO2fY3ujck3qJA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});